import { useEffect } from 'react';

import { Checkbox, FormControl, FormControlLabel, Typography } from '@mui/material';
import { FormikProps } from 'formik';

import { DropDown } from 'src/components/FormikComponents';

import { PrincipalType } from '../PrincipalForm';

type BillingContactSelectorProps = {
    formik: FormikProps<{ principal: { isBillingContact: boolean } }>;
    initialValues?: PrincipalType;
};
const BillingContactSelector = ({ formik, initialValues }: BillingContactSelectorProps) => {
    const { isBillingContact } = formik.values.principal;
    const billingContactOptions = initialValues?.principals?.map((principal, index) => {
        return {
            value: index,
            label: `${principal.firstName} ${principal.lastName}`,
        };
    });

    const shouldShowNewBillingContactDropdown =
        billingContactOptions?.length > 0 &&
        initialValues &&
        initialValues.principal.isBillingContact &&
        !isBillingContact;

    useEffect(() => {
        const shouldResetBillingContact =
            billingContactOptions?.length > 0 &&
            initialValues &&
            initialValues.principal.isBillingContact &&
            isBillingContact;

        if (shouldResetBillingContact) {
            formik.setFieldValue('newBillingContact', undefined);
            // Reset the newBillingContact field value when the editing principal was initially a billing contact
        }
    }, [isBillingContact, initialValues]);

    return (
        <>
            <FormControl component="fieldset">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isBillingContact}
                            onChange={(event) => {
                                formik.setFieldValue(
                                    'principal.isBillingContact',
                                    event.target.checked
                                );
                            }}
                        />
                    }
                    label={
                        <Typography
                            color="text.primary"
                            fontSize="14px"
                            lineHeight="21px"
                            fontWeight="700"
                        >
                            {'Is Billing Contact'}
                        </Typography>
                    }
                    labelPlacement="start"
                    sx={{
                        margin: 0,
                    }}
                />
            </FormControl>
            {/* If the initial value of the principal is a billing contact and the updated value is not a billing contact
            then show the dropwdown to select the new billing contact , this is to prevent the dropdown from showing if
            the editing principal contact is not initially a billing contact.
            */}
            {shouldShowNewBillingContactDropdown && (
                <DropDown
                    label="New Billing Contact"
                    name={`newBillingContact`}
                    options={billingContactOptions}
                    disabled={false}
                />
            )}
        </>
    );
};

export default BillingContactSelector;
